import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Index from './components/Index';

const App = () => {
  return (
    <>
      <HelmetProvider>
        <BrowserRouter>
          <Index />
        </BrowserRouter>
      </HelmetProvider>
    </>
  );
}
const element = document.getElementById('root');
ReactDOM.render(App(), element);

// Hot reload is that easy with Parcel
// @ts-ignore
if (module.hot) {
  // @ts-ignore
    module.hot.accept();
}
